import type { AxiosResponse } from "axios";
import { IReport } from "../../../models/report";
import { ISearchParams, ISearchReturn } from "../../../models/requests";
import { EReportCode } from "./ReportExecution/reportConstants";
import { REPORT_TYPE_IDS } from "./reportTypes";

type TInternalReportsSearchParams = ISearchParams & {
  ReportTypeId?: string;
};

const INTERNAL_REPORT_TYPE = {
  id: REPORT_TYPE_IDS.internal,
  name: "Internos",
  description: "Internos",
};

export const internalReports: IReport[] = [
  {
    id: "internal-crm-messages-by-establishment-monthly",
    code: EReportCode.QuantidadeDeMensagensCRMPorEstabMensal,
    reportCode: EReportCode.QuantidadeDeMensagensCRMPorEstabMensal,
    name: "Quantidade de Mensagens do CRM Por Estabelecimento (Mensal)",
    description: null,
    reportTypeId: REPORT_TYPE_IDS.internal,
    reportTypeName: INTERNAL_REPORT_TYPE.name,
    reportType: INTERNAL_REPORT_TYPE,
    type: INTERNAL_REPORT_TYPE,
    created: null,
    lastModified: null,
  },
  {
    id: "internal-digital-signatures-by-establishment-monthly",
    code: EReportCode.QuantidadesDeAssinaturasDigitaisPorEstabMensal,
    reportCode: EReportCode.QuantidadesDeAssinaturasDigitaisPorEstabMensal,
    name: "Quantidade de Assinaturas Digitais Por Estabelecimento (Mensal)",
    description: null,
    reportTypeId: REPORT_TYPE_IDS.internal,
    reportTypeName: INTERNAL_REPORT_TYPE.name,
    reportType: INTERNAL_REPORT_TYPE,
    type: INTERNAL_REPORT_TYPE,
    created: null,
    lastModified: null,
  },
  {
    id: "internal-data-bus-requests-by-establishment",
    code: EReportCode.QuantidadeDeRequisicoesBarramentoDadosPorEstab,
    reportCode: EReportCode.QuantidadeDeRequisicoesBarramentoDadosPorEstab,
    name: "Quantidade de Requisições no Barramento de Dados Por Estabelecimento",
    description: null,
    reportTypeId: REPORT_TYPE_IDS.internal,
    reportTypeName: INTERNAL_REPORT_TYPE.name,
    reportType: INTERNAL_REPORT_TYPE,
    type: INTERNAL_REPORT_TYPE,
    created: null,
    lastModified: null,
  },
];

export const isInternalReportType = (reportTypeId?: string) =>
  reportTypeId === REPORT_TYPE_IDS.internal;

export const getInternalReportById = (reportId?: string) =>
  internalReports.find((report) => report.id === reportId);

const normalizeSearch = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase();

const filterInternalReports = (searchBy?: string) => {
  const normalizedSearch = normalizeSearch(searchBy?.trim() ?? "");

  if (!normalizedSearch) return internalReports;

  return internalReports.filter((report) => {
    const searchableText = [
      report.name,
      report.description,
      report.reportTypeName,
      report.code,
      report.reportCode,
    ]
      .filter((value) => value !== undefined && value !== null)
      .join(" ");

    return normalizeSearch(searchableText).includes(normalizedSearch);
  });
};

export const getInternalReportsSearchResponse = async (
  params?: TInternalReportsSearchParams,
): Promise<AxiosResponse<ISearchReturn<IReport>>> => {
  const pageNumber = params?.PageNumber ?? 1;
  const pageSize = params?.PageSize ?? internalReports.length;
  const filteredReports = filterInternalReports(params?.SearchBy);
  const totalPages = Math.ceil(filteredReports.length / pageSize);
  const start = (pageNumber - 1) * pageSize;
  const items = filteredReports.slice(start, start + pageSize);

  return {
    data: {
      items,
      pageNumber,
      totalPages,
      totalCount: filteredReports.length,
      hasPreviousPage: pageNumber > 1,
      hasNextPage: pageNumber < totalPages,
    },
  } as AxiosResponse<ISearchReturn<IReport>>;
};
